<div class="table">
  <app-toolbar
    [options]="toolbarOptions"
    [disabled]="!!anyLoading"
    (filterApply)="onFilterApply()"
    (filterClear)="onFilterClear()"
    (headerFilterOpen)="onHeaderFilterVisibleChange($event)"
    (adding)="openAddDialog()"
    (creating)="openCreateDialog()"
    (copying)="openCopyDialog(selectedItems)"
    (editing)="openEditDialog(selectedItems)"
    (massEditing)="openMassEditDialog(selectedItems)"
    (deleting)="onDelete(selectedItems)"
    (restarting)="onRestart(selectedItems)"
    (resending)="onResend(selectedItems)"
    (turnOff)="onTurnOff(selectedItems)"
    (turnOn)="onTurnOn(selectedItems)"
    (stopping)="onStop(selectedItems)"
    (exportCSV)="onExportCSV()"
    (columnsToggle)="onColumnsSettingToggle()"
  ></app-toolbar>

  <ng-container *ngIf="headerFilterTmpRef">
    <div class="header-filter" [class.hide]="!headerFilterVisible && !headerFilterAlwaysVisible">
      <ng-container *ngTemplateOutlet="headerFilterTmpRef"></ng-container>
    </div>
  </ng-container>

  <p-table
    #table
    styleClass="p-datatable-sm"
    stateStorage="local"
    [stateKey]="options?.useStorage ? tableName : undefined"
    [tableStyle]="items.length ? { 'min-width': '75rem' } : { width: '100%' }"
    [value]="items"
    [dataKey]="dataKey"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    [columns]="columns"
    [first]="first"
    [rows]="rows"
    [selectionMode]="selectionMode"
    [sortField]="defaultOptions?.sortField"
    [sortOrder]="defaultOptions?.sortOrder || 1"
    [paginator]="paginator && items.length ? true : false"
    [rowsPerPageOptions]="rowsPerPageOptions"
    [totalRecords]="totalRecords"
    [loading]="anyLoading"
    [resizableColumns]="true"
    [reorderableColumns]="true"
    columnResizeMode="expand"
    [showCurrentPageReport]="true"
    [currentPageReportTemplate]="currentPageReportTemplate"
    [(selection)]="selectedItems"
    (onLazyLoad)="loadItems($event)"
    (selectionChange)="onSelectionChange($event)"
    (onColReorder)="setColumns($event)"
    (onStateRestore)="stateRestore($event)"
  >
    <ng-template *ngIf="options?.captionOptions?.visible" pTemplate="caption">
      <table-caption [options]="options?.captionOptions"></table-caption>
    </ng-template>

    <ng-template pTemplate="header" let-columns>
      <tr *ngIf="columns.length">
        <th *ngIf="viewDialogTmpRef" style="width: 4rem"></th>

        <th *ngIf="selectionMode === 'multiple'" style="width: 4rem">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>

        <th
          *ngFor="let column of columns"
          [pSortableColumn]="
            columnOptions?.sorting && !columnOptions?.excludeFieldsSorting?.includes(column.field)
              ? column.field
              : undefined
          "
          pResizableColumn
          pReorderableColumn
          id="th"
        >
          <div class="table-column-header">
            <span class="table-column-header__label">
              {{ column.field | caption: tableName }}
            </span>

            <span class="table-column-header__actions">
              <p-sortIcon
                *ngIf="columnOptions?.sorting && !columnOptions?.excludeFieldsSorting?.includes(column.field)"
                [field]="column.field"
              ></p-sortIcon>

              <ng-container
                *ngIf="columnOptions?.filtering && !columnOptions?.excludeFieldsFiltering?.includes(column.field)"
              >
                <p-columnFilter
                  [field]="column.field"
                  [type]="getColumnFilterType(column.field)"
                  matchMode="equals"
                  display="menu"
                >
                  <ng-container *ngIf="!!columnOptions?.columnFilterDictionaryFields?.includes(column.field)">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-dropdown
                        [ngModel]="value"
                        [options]="columnFilterDictionaryValues[column.field]"
                        optionLabel="title"
                        optionValue="name"
                        [editable]="true"
                        placeholder="Выбрать"
                        (onChange)="filter($event.value)"
                      />
                    </ng-template>
                  </ng-container>
                </p-columnFilter>
              </ng-container>
            </span>
          </div>
        </th>

        <th *ngIf="rowMenuOptions?.visible"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item let-columns="columns">
      <tr *ngIf="!anyLoading" [pSelectableRow]="item">
        <td *ngIf="viewDialogTmpRef">
          <p-button
            *ngIf="viewDialogTmpRef"
            class="button-icon"
            icon="pi pi-eye"
            [size]="'small'"
            severity="secondary"
            [rounded]="true"
            [text]="true"
            [pTooltip]="'Просмотр'"
            [tooltipPosition]="'bottom'"
            (click)="openViewDialog(item)"
          />
        </td>

        <td *ngIf="selectionMode === 'multiple'">
          <p-tableCheckbox [value]="item" (click)="onClickCheckboxItem($event)"></p-tableCheckbox>
        </td>

        <td *ngFor="let column of columns">
          <ng-container *ngIf="!columnsTemplates?.[column.field]; else columnTmp">
            {{ item[column.field] }}
          </ng-container>
          <ng-template #columnTmp>
            <div class="content">
              <ng-container
                *ngTemplateOutlet="columnsTemplates![column.field]!; context: { value: item[column.field] }"
              ></ng-container>
            </div>
          </ng-template>
        </td>

        <td *ngIf="rowMenuOptions?.visible">
          <row-menu
            [options]="rowMenuOptions"
            (copying)="openCopyDialog([item])"
            (editing)="openEditDialog([item])"
            (deleting)="onDelete([item])"
            (restarting)="onRestart([item])"
            (resending)="onResend([item])"
            (turnOff)="onTurnOff([item])"
            (turnOn)="onTurnOn([item])"
            (stopping)="onStop([item])"
          ></row-menu>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="loadingbody">
      <table-loading-timer
        *ngIf="options?.loadingTimer"
        class="loading-timer"
        (stop)="stopLoadItems()"
      ></table-loading-timer>

      <tr *ngFor="let col of [].constructor(rows && items.length > 0 && items.length < rows ? items.length : rows)">
        <td *ngIf="selecting" class="load">
          <skeleton-row-text></skeleton-row-text>
        </td>
        <td *ngFor="let col of [].constructor(columns.length)" class="load">
          <skeleton-row-text></skeleton-row-text>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="paginatorleft"></ng-template>

    <ng-template pTemplate="paginatorright">
      <p-button type="button" [text]="true" label="Очистить кэш" (click)="onClearCacheTable(tableName)" />
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <td [attr.colspan]="columns.length">
        <app-info-block
          [imageSrc]="infoBlockNotFound.imageSrc"
          [title]="infoBlockNotFound.title"
          [description]="infoBlockNotFound.description"
        ></app-info-block>
      </td>
    </ng-template>
  </p-table>

  <ng-template #noFilter>
    <app-info-block
      [imageSrc]="infoBlockNoFilter.imageSrc"
      [title]="infoBlockNoFilter.title"
      [description]="infoBlockNoFilter.description"
    ></app-info-block>
  </ng-template>
</div>

<!-- Диалог добавления записи -->
<app-dialog
  [data]="addData"
  [options]="addDialogOptions"
  [contentTemplateRef]="addDialogTmpRef"
  (accept)="onAdd()"
  (reject)="onCancelAdding()"
  (close)="onCloseDialog()"
></app-dialog>

<!-- Диалог создания записи -->
<app-dialog
  [data]="copyData"
  [options]="createDialogOptions"
  [contentTemplateRef]="createDialogTmpRef"
  (accept)="onCreate()"
  (reject)="onCancelCreating()"
  (close)="onCloseDialog()"
></app-dialog>

<!-- Диалог редактирования записи -->
<app-dialog
  [data]="editData"
  [options]="editDialogOptions"
  [contentTemplateRef]="editDialogTmpRef"
  (accept)="onEdit(editData)"
  (reject)="onCancelEditing()"
  (close)="onCloseDialog()"
></app-dialog>

<!-- Диалог массового редактирования записи -->
<app-dialog
  [data]="massEditData"
  [options]="massEditDialogOptions"
  [contentTemplateRef]="massEditDialogTmpRef"
  (accept)="onMassEdit(massEditData)"
  (reject)="onCancelMassEditing()"
  (close)="onCloseDialog()"
></app-dialog>

<!-- Диалог просмотра записи -->
<app-dialog
  [data]="viewData"
  [options]="viewDialogOptions"
  [contentTemplateRef]="viewDialogTmpRef"
  (close)="onCloseDialog()"
></app-dialog>

<!-- Диалог выбора колонок -->
<table-columns-setting-dialog
  [(visible)]="columnsSettingVisible"
  [allColumns]="allColumns"
  [(selectedColumns)]="columns"
  (selectedColumnsChange)="stateSave()"
></table-columns-setting-dialog>

<ng-template #confirmDialog></ng-template>
